import { app } from '../../../../bootstrap/core';
import { transferListComponent } from './transferList.component';

app.component(transferListComponent.name, transferListComponent);



// WEBPACK FOOTER //
// ./src/app/components/overview/components/transferList/transferList.js